import React from 'react';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { patientActions } from '_actions';
import {
    PatientDot,
    EditNoteButton,
    PatientCareCenterButton,
    LoadingIcon
} from '_components'
import messageCenterCommonStyles from 'MessageCenter/Common.module.css'
import styles from './Details.module.css'

class DischargeDueDetails extends React.Component {

    getDays() {
        let first = new Date(this.props.message.lastSeen)
        let second = new Date();
        second.setHours(0, 0, 0, 0);
        return Math.round((second - first) / (1000 * 60 * 60 * 24));
    }

    startNote() {
        this.props.openPatientStartNote(this.props.message.ptno, this.props.message.epno, undefined, undefined, 4);
    }

    render() {
        var options = { year: '2-digit', month: 'numeric', day: 'numeric' };

        if (this.props.message)
            return (
                <div className={messageCenterCommonStyles.message_center_details_wrapper} >
                    <div className={messageCenterCommonStyles.message_header}>Discharge Due: {this.props.message.ptname}</div>
                    <hr className={messageCenterCommonStyles.message_header_separator} />

                    <div className={styles.details_table}>
                        <div className={styles.details_cell} >
                            <div className={styles.labels}>
                                <div>Patient:</div>
                                <div>Admission:</div>
                                <div>Last Visit:</div>
                            </div>
                            <div className={styles.data}>
                                <div className={this.props.message.isFederal ? styles.italic : ''}><span className={styles.patient_dot}><PatientDot id={this.props.message.dot} /></span>{' ' + this.props.message.ptname + ' (SYS#' + this.props.message.ptno + ')'}</div>
                                <div>{this.props.message.admissionDesc + ' - ' + this.props.message.discipline + ' - ' + this.props.message.locationName}</div>
                                <div>{new Date(this.props.message.lastSeen).toLocaleDateString("en-US", options)}</div>
                            </div>
                        </div>
                        <div className={styles.button_wrapper}>
                            <div className={styles.button_div}>
                                {!this.props.isAide &&
                                    <span className={styles.button}><EditNoteButton onClick={() => this.startNote()} title={'Create Discharge'} /></span>
                                }
                                <span className={styles.button}><PatientCareCenterButton ptno={this.props.message.ptno} /></span>
                            </div>
                        </div>
                    </div>

                    <div className={styles.wrapper}>
                        This admission has not been treated in
                        <span className={styles.num_days}>{' ' + this.getDays() + ' '}</span>
                        days.  Please perform a discharge.
                    </div>


                </div>
            );
        else
            return (
                <div className={messageCenterCommonStyles.message_center_details_wrapper} >
                    <div className={messageCenterCommonStyles.message_header}>Discharge Due</div>
                    <hr className={messageCenterCommonStyles.message_header_separator} />
                    {this.props.loading === true ?
                        <LoadingIcon size="small" />
                        : <div className={styles.italic}>No Message Selected</div>
                    }
                </div>
            );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        openPatientStartNote: bindActionCreators(patientActions.openStartNote, dispatch)
    };
}

function mapStateToProps(state) {
    let message = state.entities.dcDue[state.ui.dcDue.selectedMessage];
    let isAide = state.entities.authentication.user.isAide;

    return {
        message,
        isAide,
        loading: state.ui.dcDue.loading,
    };
}


const connectedDischargeDueDetails = connect(mapStateToProps, mapDispatchToProps)(DischargeDueDetails);
export { connectedDischargeDueDetails as DischargeDueDetails };
